import { Box, Flex, Input } from '@chakra-ui/react'

import IconPlus from '@/components/icons/IconPlus'
import IconSearch from '@/components/icons/IconSearch'
import Button from '@/components/ui/Button'
import { H2 } from '@/components/ui/Headings'

interface LibraryHeaderProps {
  searchTerm: string
  onSearchChange: (e: React.ChangeEvent<HTMLInputElement>) => void
  onCreateClick: () => void
}

export default function LibraryHeader({
  searchTerm,
  onSearchChange,
  onCreateClick
}: LibraryHeaderProps) {
  return (
    <Flex justify="space-between" align="center" mb={5} flexWrap="wrap" gap={4}>
      <H2 color="text.primary" fontWeight={500}>
        Browse IP Library
      </H2>

      <Flex gap={3} align="center">
        <Box position="relative" display={{ base: 'none', md: 'block' }}>
          <Box
            position="absolute"
            left="12px"
            top="50%"
            transform="translateY(-50%)"
            zIndex={1}
            display="flex"
            alignItems="center"
          >
            <IconSearch boxSize="16px" color="text.tertiary" />
          </Box>
          <Input
            value={searchTerm}
            onChange={onSearchChange}
            placeholder="Search IP Groups..."
            w="300px"
            h="44px"
            pl="36px"
            bg="bg.secondary"
            border="1px solid"
            borderColor="border.subtle"
            borderRadius="8px"
            color="text.primary"
            _placeholder={{ color: 'text.tertiary' }}
            _focus={{
              borderColor: 'accent.500',
              boxShadow: 'none'
            }}
          />
        </Box>

        <Button
          variant="primary"
          h="44px"
          px={4}
          fontWeight={600}
          onClick={onCreateClick}
          display={{ base: 'none', md: 'flex' }}
        >
          <Flex align="center" gap="6px">
            <IconPlus boxSize="20px" />
            Create IP Group
          </Flex>
        </Button>
      </Flex>
    </Flex>
  )
}
